"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7755],{

/***/ 57416:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64384);
/* harmony import */ var _api_baskets__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(18682);
/* harmony import */ var _common_splicePrice__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(8025);
/* harmony import */ var _redux_action_cart__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(68866);
/* harmony import */ var _redux_action_quickViewAction__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(43181);
/* harmony import */ var _redux_action_alert__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4557);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67294);
/* harmony import */ var _common_alert__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(55150);
/* harmony import */ var _redux_action_baskets__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(83173);
/* harmony import */ var _common_auth__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(48106);
/* harmony import */ var _SingleProduct_styles__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(74971);
/* harmony import */ var _api_products__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(81628);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
















var SingleProduct = function(param) {
    var product1 = param.product, basketsItems = param.basketsItems, cartItems = param.cartItems, basketsCount = param.basketsCount, _$addToCart = param.addToCart, addToWishlist = param.addToWishlist, _$openQuickView = param.openQuickView, _$increaseCnt = param.increaseCnt, _$showToastAlert = param.showToastAlert, _$insertBasketsAction = param.insertBasketsAction, _$fetchBasketsAction = param.fetchBasketsAction, dummyList = param.dummyList, addCart = param.addCart, inCart = param.inCart;
    var inBasket = inCart ? inCart(product1) : (basketsItems === null || basketsItems === void 0 ? void 0 : basketsItems.find(function(basketsItem) {
        return basketsItem.pcode === product1.pcode;
    })) || (cartItems === null || cartItems === void 0 ? void 0 : cartItems.find(function(cartItem) {
        return cartItem.pcode === product1.pcode;
    }));
    var handleCart = function() {
        var _ref = _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(product) {
            return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (product) {
                            dataLayer.push({
                                ecommerce: null
                            }); // Clear the previous ecommerce object.
                            dataLayer.push({
                                event: "add_to_cart",
                                ecommerce: {
                                    items: [
                                        {
                                            item_name: product.pname,
                                            item_id: product.pcode,
                                            price: product.price,
                                            item_brand: product.supplier,
                                            item_category: product.category_code.length > 2 ? product.category_code : dummyList === null || dummyList === void 0 ? void 0 : dummyList.category[product.category_code]
                                        }, 
                                    ]
                                }
                            });
                            // 채널톡 장비구니 이벤트
                            window.ChannelIO("track", "AddToCart", {
                                pcode: product.pcode
                            });
                        }
                        if ((0,_common_auth__WEBPACK_IMPORTED_MODULE_9__/* .getCookie */ .ej)("token")) {
                            _ctx.next = 5;
                            break;
                        }
                        return _ctx.abrupt("return", _$addToCart(product));
                    case 5:
                        return _ctx.abrupt("return", _$insertBasketsAction(product, 1));
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleCart(product) {
            return _ref.apply(this, arguments);
        };
    }();
    var moveToDetail = function() {
        var _ref = _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var body, res;
            return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        body = {
                            modes: "ViewCount",
                            pcode: product1.pcode
                        };
                        _ctx.next = 3;
                        return (0,_api_products__WEBPACK_IMPORTED_MODULE_11__/* .ViewCountProduct */ .Ir)(body);
                    case 3:
                        res = _ctx.sent;
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function moveToDetail() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_SingleProduct_styles__WEBPACK_IMPORTED_MODULE_10__/* .Wrapper */ .im, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_SingleProduct_styles__WEBPACK_IMPORTED_MODULE_10__/* .ProductImgWrapper */ .Q5, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                            href: "/products/".concat(product1 === null || product1 === void 0 ? void 0 : product1.ename, "/").concat(product1.pcode, "/"),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_SingleProduct_styles__WEBPACK_IMPORTED_MODULE_10__/* .ProductImg */ .pm, {
                                onClick: moveToDetail,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                                    src: product1.main_image,
                                    alt: ""
                                })
                            })
                        }),
                        product1.sfnz_view === "Y" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_SingleProduct_styles__WEBPACK_IMPORTED_MODULE_10__/* .SfnzBadge */ .L4, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                                src: "https://file.caretbio.com/caretbio/75378c147862e82d7a9ede3651163fdd.png",
                                alt: "SFNZ_badge"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_SingleProduct_styles__WEBPACK_IMPORTED_MODULE_10__/* .ProductContentWrapper */ .ZD, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                            href: "/products/".concat(product1 === null || product1 === void 0 ? void 0 : product1.ename, "/").concat(product1.pcode, "/"),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_SingleProduct_styles__WEBPACK_IMPORTED_MODULE_10__/* .ProductName */ .rZ, {
                                onClick: moveToDetail,
                                children: product1.pname
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_SingleProduct_styles__WEBPACK_IMPORTED_MODULE_10__/* .ProductBottomWrapper */ .qW, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_SingleProduct_styles__WEBPACK_IMPORTED_MODULE_10__/* .PriceWrapper */ .vN, {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_SingleProduct_styles__WEBPACK_IMPORTED_MODULE_10__/* .PriceBox */ .bz, {
                                        children: [
                                            product1.salePer > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("span", {
                                                        children: [
                                                            product1.salePer,
                                                            "%"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                                        children: product1.price && " ".concat((0,_common_splicePrice__WEBPACK_IMPORTED_MODULE_12__/* .priceComma */ .a)(product1.price), "\uC6D0")
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                className: "d-flex",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("h5", {
                                                    children: [
                                                        (0,_common_splicePrice__WEBPACK_IMPORTED_MODULE_12__/* .priceComma */ .a)(product1.discount_price),
                                                        "\uC6D0"
                                                    ]
                                                })
                                            }),
                                            Number(product1.quantity) > 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                style: {
                                                    // paddingBottom: "5px",
                                                    fontSize: "14px"
                                                },
                                                children: [
                                                    "\uAC1C\uB2F9",
                                                    " ",
                                                    (0,_common_splicePrice__WEBPACK_IMPORTED_MODULE_12__/* .priceComma */ .a)(Math.floor(Number(product1.discount_price) / Number(product1.quantity))),
                                                    "\uC6D0"
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                product1.sold_out === "Y" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_SingleProduct_styles__WEBPACK_IMPORTED_MODULE_10__/* .CartIconBox */ .d4, {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                        children: "\uD488\uC808"
                                    })
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_SingleProduct_styles__WEBPACK_IMPORTED_MODULE_10__/* .CartIconBox */ .d4, {
                                    children: !inBasket ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                                        className: "mobonCart",
                                        onClick: function(e) {
                                            return addCart ? addCart(product1) : handleCart(product1);
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("i", {
                                            className: "fi-rs-shopping-cart-add"
                                        })
                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                                        onClick: function(e) {
                                            return addCart ? addCart(product1) : handleCart(product1);
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("i", {
                                            className: "fi-rs-shopping-cart-check"
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_SingleProduct_styles__WEBPACK_IMPORTED_MODULE_10__/* .StickerWrapper */ .Mo, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_SingleProduct_styles__WEBPACK_IMPORTED_MODULE_10__/* .ViewBox */ .HA, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                        children: [
                                            (0,_common_splicePrice__WEBPACK_IMPORTED_MODULE_12__/* .priceComma */ .a)(product1.point),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_SingleProduct_styles__WEBPACK_IMPORTED_MODULE_10__/* .Sticker */ .My, {
                                                children: "P"
                                            }),
                                            " \uC801\uB9BD"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                                                src: "/assets/imgs/theme/icons/icon-view.png"
                                            }),
                                            product1.hit
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var mapStateToProps = function(state) {
    return {
        cartItems: state.cart,
        basketsItems: state.baskets.items,
        basketsCount: state.baskets.count
    };
};
var mapDispatchToProps = {
    addToCart: _redux_action_cart__WEBPACK_IMPORTED_MODULE_13__/* .addToCart */ .Xq,
    openQuickView: _redux_action_quickViewAction__WEBPACK_IMPORTED_MODULE_14__/* .openQuickView */ .$,
    increaseCnt: _redux_action_cart__WEBPACK_IMPORTED_MODULE_13__/* .increaseCnt */ .us,
    showToastAlert: _redux_action_alert__WEBPACK_IMPORTED_MODULE_5__/* .showToastAlert */ .I,
    insertBasketsAction: _redux_action_baskets__WEBPACK_IMPORTED_MODULE_8__/* .insertBasketsAction */ .el,
    fetchBasketsAction: _redux_action_baskets__WEBPACK_IMPORTED_MODULE_8__/* .fetchBasketsAction */ .Ei
};
/* harmony default export */ __webpack_exports__["Z"] = ((0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .connect */ .$j)(mapStateToProps, mapDispatchToProps)(SingleProduct));


/***/ }),

/***/ 45063:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var _ecommerce_singleProduct_SingleProduct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57416);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  @media (max-width: 575px) {\n    width: 50% !important;\n  }\n  @media (max-width: 349px) {\n    width: 100% !important;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var SingleProductTap = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-7d0b337f-0"
})(_templateObject());
var FeaturedTab = function(param) {
    var products = param.products;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: products && (products === null || products === void 0 ? void 0 : products.map(function(product, i) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SingleProductTap, {
                className: "col-12 col-lg-1-5 col-md-4 col-sm-6",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ecommerce_singleProduct_SingleProduct__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    product: product
                })
            }, i);
        }))
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FeaturedTab);


/***/ }),

/***/ 75038:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "E": function() { return /* binding */ useGetBestProductsList; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/modern/useQuery.js + 7 modules
var useQuery = __webpack_require__(87633);
// EXTERNAL MODULE: ./common/queryKeys.js
var queryKeys = __webpack_require__(51586);
// EXTERNAL MODULE: ./api/constants/http.js
var http = __webpack_require__(23359);
// EXTERNAL MODULE: ./api/constants/resources.js
var resources = __webpack_require__(41238);
;// CONCATENATED MODULE: ./api/bestProducts.js
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



// 카테고리텝 상품목록
var BestProductsListSet = function() {
    var _ref = _asyncToGenerator(runtime_default().mark(function _callee(body) {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,http/* default */.Z)(resources/* default.PRODUCTS */.Z.PRODUCTS).post(body);
                case 2:
                    res = _ctx.sent;
                    if (!(res.status === 200)) {
                        _ctx.next = 7;
                        break;
                    }
                    return _ctx.abrupt("return", res.data);
                case 7:
                    return _ctx.abrupt("return", res);
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function BestProductsListSet(body) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./hook/best-products/useBestProductsQuery.js
function useBestProductsQuery_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function useBestProductsQuery_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                useBestProductsQuery_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                useBestProductsQuery_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}




// 카테고리 상세내용 불러오기
var useGetBestProductsList = function(param) {
    var limit = param.limit;
    var queryKey = limit === "4" ? [
        queryKeys/* QUERY_KEYS.PRODUCTS.BESTPRODUCTS.DETAIL */.U.PRODUCTS.BESTPRODUCTS.DETAIL
    ] : [
        queryKeys/* QUERY_KEYS.PRODUCTS.BESTPRODUCTS.INDEX */.U.PRODUCTS.BESTPRODUCTS.INDEX,
        limit
    ];
    return (0,useQuery/* useQuery */.a)({
        queryKey: queryKey,
        queryFn: useBestProductsQuery_asyncToGenerator(runtime_default().mark(function _callee() {
            var res;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return BestProductsListSet({
                            modes: "BestListSet",
                            limit: limit
                        });
                    case 3:
                        res = _ctx.sent;
                        if (!(res.Code === "0000")) {
                            _ctx.next = 8;
                            break;
                        }
                        return _ctx.abrupt("return", res.Data.Data || {});
                    case 8:
                        {
                            console.error(res === null || res === void 0 ? void 0 : res.message); // 에러 처리
                        }
                    case 9:
                        _ctx.next = 14;
                        break;
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t0 = _ctx["catch"](0);
                        console.error(_ctx.t0); // 네트워크 에러 등
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    11
                ]
            ]);
        })),
        staleTime: 1000 * 60 * 5,
        retry: 1
    });
};


/***/ }),

/***/ 43181:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ openQuickView; },
/* harmony export */   "z": function() { return /* binding */ closeQuickView; }
/* harmony export */ });
/* harmony import */ var _constants_actionTypes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46330);

var openQuickView = function(product) {
    return function(dispatch) {
        dispatch({
            type: _constants_actionTypes__WEBPACK_IMPORTED_MODULE_0__/* .OPEN_QUICK_VIEW */ .GS,
            payload: {
                product: product
            }
        });
    };
};
var closeQuickView = function() {
    return function(dispatch) {
        dispatch({
            type: _constants_actionTypes__WEBPACK_IMPORTED_MODULE_0__/* .CLOSE_QUICK_VIEW */ .fJ
        });
    };
};


/***/ })

}]);